import React, { useState} from 'react';

const  DropDown = ({nameDropDown, children}) =>{ 
  const [open, setOpen] = useState(false);

  return (
    <li className="nav-item">
      <div className="icon-button" onClick={() => setOpen(!open)}>
        {nameDropDown}
      </div>
      {open && children}
    </li>
  );
}

export default DropDown